<mat-card>
  <mat-card-content>
    <div id="userMenu" class="flexColumnContainer">
      <div id="header" class="flexRowContainer">
        <button id="placeholderButton" mat-icon-button>
          <mat-icon></mat-icon>
        </button>
        <p class="title-small">{{ user?.email }}</p>
        <button mat-icon-button (click)="closeUserMenu.emit()" (keydown.enter)="closeUserMenu.emit()"
                aria-label="Close User Menu">
          <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
      </div>
      <span id="userIcon" class="headline-small">{{ userInitials }}</span>
      <p id="welcomeMessage"
         class="headline-small">{{ 'userMenu.welcomeMessage' | translate:{name: user?.firstName} }}</p>
      <button class="textButtons" mat-stroked-button [disabled]="!teamSelected" (click)="changeTeam()"
              (keydown.enter)="changeTeam()"
              aria-label="Change Team">
        <mat-icon class="material-symbols-outlined">change_circle</mat-icon>
        <span class="label-large">{{ 'userMenu.buttons.changeTeam.text' | translate }}</span>
      </button>
      <button id="logoutButton" class="textButtons" mat-flat-button (click)="logout()" (keydown.enter)="logout()"
              aria-label="Logout">
        <mat-icon class="material-symbols-outlined">logout</mat-icon>
        <span class="label-large">{{ 'userMenu.buttons.logout.text' | translate }}</span>
      </button>
      <p id="legal" hidden>
        <a class="body-small" href="https://pointerpointer.com/">{{ 'userMenu.legal.privacyPolicy' | translate }}</a>
        <span> - </span>
        <a class="body-small" href="https://pablotheflamingo.com/">{{ 'userMenu.legal.termsOfService' | translate }}</a>
      </p>
    </div>
  </mat-card-content>
</mat-card>
